import TreeMap from "./treeMap.js";

export default TreeMap;



// WEBPACK FOOTER //
// ./src/components/d3Components/treeMap/index.js